<template>
  <div>
    <div
      v-for="(item, index) in optionList.optionList"
      :key="index"
      class="box"
    >
      <div class="roseChart" id="echarts">
        <div v-if="item.type == 1" style="text-align: center">
          <h2>{{ item.title }}</h2>
          <p v-for="(x, y) in item.tiankongList" :key="y" style="text-align: left">
            <span >{{y+1}}、</span>
            {{ x }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["ResultData"],
  data() {
    return {
      optionList: [],
      name: [],
      dataList: [],
    };
  },
  mounted() {
    this.getList(this.ResultData);
  },
  watch: {
    ResultData(newVal, oldVal) {
      this.getList(newVal);
    },
  },
  methods: {
    getList(id) {
      this.getAxios(`/wenjuan/result?id=${id}`).then((res) => {
        if (res.success == true) {
          this.optionList = res.entity;
          this.$nextTick(() => {
            var that = this;
            that.drawLine();
          });
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    drawLine() {
      var echarts = require("echarts");
      var roseCharts = document.getElementsByClassName("roseChart"); // 对应地使用ByClassName
      for (var i = 0; i < roseCharts.length; i++) {
        if (this.optionList.optionList[i].type != 1) {
          var myChart = echarts.init(roseCharts[i]);
          this.optionList.optionList[i].contentList.map((x) => {
            this.optionList.optionList[i].contentList.push({
              value: x.voteCount,
              name: x.content,
            });
          });
          var option = {
            color: [
              "#27727B",
              "#5D84FF",
              "#C1232B",
              "#B5C334",
              "#FCCE10",
              "#E87C25",
              "#FE8463",
              "#9BCA63",
              "#FAD860",
              "#F3A43B",
              "#60C0DD",
              "#D7504B",
              "#C6E579",
              "#F4E001",
              "#F0805A",
              "#26C0C0",
            ],
            title: {
              text: this.optionList.optionList[i].title,
              left: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              orient: "vertical",
              left: "left",
              data: this.optionList.optionList[i].contentList,
            },
            series: [
              {
                name: "",
                type: "pie",
                radius: "70%",
                center: ["50%", "60%"],
                data: this.optionList.optionList[i].contentList,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.roseChart {
  width: 100%;
  min-height: 200px;
}
.box {
  padding: 30px 0;
  border-bottom: 1px dashed #000;
}
h2 {
  font-weight: bold;
}
</style>